import type {
  OtrosProyectos,
  OtrasActuaciones,
  OtrasTransacciones,
} from "@/types/models/otros";

function getRelationId(value: unknown): number | null {
  if (value == null) return null;

  if (typeof value === "number") return value;

  if (typeof value === "string" && value.trim()) {
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  }

  if (typeof value === "object" && "id" in value) {
    return getRelationId((value as { id?: unknown }).id);
  }

  return null;
}

export function mapOtrosProyectosWithRelations(params: {
  proyectos: OtrosProyectos[];
  actuaciones: OtrasActuaciones[];
  transacciones: OtrasTransacciones[];
}): OtrosProyectos[] {
  const { proyectos, actuaciones, transacciones } = params;

  return proyectos.map((proyecto) => {
    const proyectoId = Number(proyecto.id);

    const proyectoActuaciones = actuaciones
      .filter(
        (actuacion) =>
          getRelationId(actuacion.otro_proyecto) === proyectoId
      )
      .map((actuacion) => {
        const actuacionId = Number(actuacion.id);

        const actuacionTransacciones = transacciones
          .filter(
            (transaccion) =>
              getRelationId(transaccion.otra_actuacion) === actuacionId
          )
          .map((transaccion) => ({
            ...transaccion,
            otra_actuacion: actuacion,
          }));

        return {
          ...actuacion,
          otras_transacciones: actuacionTransacciones,
        };
      });

    return {
      ...proyecto,
      otras_actuaciones: proyectoActuaciones,
    };
  });
}